import React from 'react'
import Link from 'gatsby-link'
import RegisterForm from '../components/enqForm'
import styled from 'styled-components'
import * as vars from '../style/vars'
import { above, below } from '../style/functions'

const FooterForm = (props) => {
	function scroll(e) {
		if (typeof window !== `undefined`) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		}
	}

	//console.log(props);

	return (
		<FooterWrapper>
			<div className='grid'>
				<div className='inner'>
					<Box id='footer_enquire'>
						<Title>Enquire now.</Title>
						<RegisterForm
							property={props.property}
							utm={props.utm}
							updateFormDetails={(first_name, last_name, phone, email, property) =>
								props.updateFormDetails(
									first_name,
									last_name,
									phone,
									email,
									property
								)
							}
						/>
					</Box>
					<Box>
						<Title>Book a viewing.</Title>
						<p>
							Discover The World's Most Liveable Suburb. <br /> Experience our Display
							Suite.
						</p>

						<Link
							to={{ pathname: '/booking', state: { property: props.property } }}
							className='btn btn-square'
						>
							<span>Book an appointment</span>
						</Link>
					</Box>
					<div className='last-wrapper'>
						<Box>
							<p className='underline'>Display Suite</p>
							<p>
								*Our Display Suite is open <a className='l--inline' href="/booking" target="_blank">by appointment</a>, alternatively <a className='l--inline' href="/booking" target="_blank">book your digital appointment</a> with our Property Consultants today.
							</p>
							<Contact>
								<div className='hours'>
									<p>
										39 Mills Boulevard,
										<br />
										Alphington VIC 3078
										<br />
										<a className='la--n' href='tel:+61395738320'>
											+61 (0)3 9573 8320
										</a>
									</p>
									<a
										href='https://goo.gl/maps/bBfuRiYBG9T2'
										className='view-map'
										target='_blank'
										rel='noopener noreferrer'
									>
										<span>View map</span>
									</a>
								</div>
							</Contact>
						</Box>
					</div>
				</div>
			</div>
		</FooterWrapper>
	)
}

const FooterWrapper = styled.footer`
	background: ${vars.colors.offColor};
	padding: 5rem 0 0rem;
	color: ${vars.colors.body};
	position: relative;
	z-index: 6;
	width: 100%;
	left: 0;
	right: 0;
	.inner {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		${below.tablet`
				display: block;
			`}
	}

	${below.tablet`
      flex-wrap: nowrap;
      flex-direction: column;
      padding: ${vars.padding.tabInner}rem 0 0;
  `};

	.last-wrapper {
		flex: 0 0 50%;
		margin-bottom: 5rem;
		${below.tablet`
         flex: 0 0 100%;
         margin-bottom: 0;
      `};
	}
`

const Box = styled.div`
	flex: 1 0 48%;
	margin: 0 0.5%;

	p.underline {
		padding-bottom: 0;
		margin-bottom: 1rem;
		border-bottom: 1px solid ${vars.colors.body};
	}

	a.l--inline:after {
		display: none;
	}

	${below.tablet`
      width: 98%;
      margin-bottom: 6rem;
   `};
`

const Title = styled.h3`
   /* border-bottom: 2px solid ${vars.colors.blank}; */
   padding-bottom: 1rem;
   margin-bottom: 1rem;
`

const Contact = styled.div`
	display: flex;
	a {
		transition: margin-left 0.3s;
		/* &:hover {
         margin-left: 1rem;
      } */
	}
	.hours {
		width: 70%;
		p:first-of-type {
			padding-bottom: 5px;
		}
	}

	a.view-map {
		font-size: 1.5rem;
		text-decoration: none;
		display: block;
		margin-bottom: 0.8rem;

		span {
			text-decoration: underline;
		}

		:after {
			content: ' →';
			text-decoration: none;
			transition: margin-left 0.5s;
		}
		:hover:after {
			margin-left: 0.5rem;
		}
	}

	${below.tablet`
    flex-direction: column;
    .hours {
       width: 100%;
    }

    .phone {
      margin-top: 1rem;
    }
  `};
`

export default FooterForm



// WEBPACK FOOTER //
// ./src/components/footerForm.js